export default __webpack_public_path__ + "static/media/hero-premium@2x.57e98305.png";